import { memo, type ReactNode } from 'react';
import { useResizeDetector } from 'react-resize-detector';

import { AssetModalContentControlsDensityProvider } from '~/components/AssetModalV2/Content/Footer/contexts/AssetModalContentControlsDensityContext';
import { AssetModalContentDesktopLayoutFooter } from '~/components/AssetModalV2/components/AssetModalContentDesktopLayoutFooter';

export type MobileVideoVisualizerFooterProps = {
  children: ReactNode;
};

export const MobileVideoVisualizerFooter = memo(({ children }: MobileVideoVisualizerFooterProps) => {
  const { ref, width = 0 } = useResizeDetector<HTMLDivElement>({
    handleHeight: false,
    refreshMode: 'throttle',
    refreshRate: 100,
  });

  return (
    <div className="relative h-12 w-full shrink-0" ref={ref}>
      <AssetModalContentControlsDensityProvider centerContentWidth={width}>
        <AssetModalContentDesktopLayoutFooter>{children}</AssetModalContentDesktopLayoutFooter>
      </AssetModalContentControlsDensityProvider>
    </div>
  );
});

MobileVideoVisualizerFooter.displayName = 'MobileVideoVisualizerFooter';
